<template>
  <div class="downloadB">
    <div class="logo">
      <i :class="['iconfont',downloadInfo.logo]"></i>
    </div>
    <div class="version">v{{downloadInfo.version}}</div>
    <!-- <div class="version">v1.3.0</div> -->
    <div class="downloadBtn">
      <a :href="downloadInfo.downloadUrl" @click="download(downloadInfo.text)">{{downloadInfo.text}}</a>
    </div>
  </div>
</template>

<script>
import { uploadBussinessLog } from "@/js/utils/bussinessLog";
export default {
  props: {
    downloadInfo: {
      type: Object
    }
  },
  methods: {
    download(os) {
      if (os.includes("Win")) {
        uploadBussinessLog("59af16f14766be2dee81f7ef7da50fc5", "click");
      } else {
        uploadBussinessLog("338d88ac6613e56169b81aa973ea07ce", "click");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.downloadB {
  width: 380px;
  height: 226px;
  background: #ffffff;
  box-shadow: 0px 12px 13px 0px rgba(152, 168, 255, 0.12);
  border-radius: 8px;
  position: relative;
  .logo {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 100px;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 10px 11px 0px rgba(152, 168, 255, 0.12);
    border-radius: 2px;
    .iconfont {
      font-size: 40px;
      color: rgb(153, 153, 153);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .version {
    margin-top: 88px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
  }
  .downloadBtn {
    // margin-top: 24px;
    margin: 24px auto;
    width: 210px;
    height: 54px;
    line-height: 54px;
    border-radius: 29px;
    // opacity: 0.5;
    border: 1px solid rgba(#999999, 0.5);

    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
      text-align: center;

    a {
      text-decoration: none;
      color: rgba(#333333, 0.5);
    }
  }

  &:hover {
    .logo {
      .iconfont {
        color: rgb(67, 95, 255);
      }
    }
    .downloadBtn {
      border: 1px solid #435fff;
      font-weight: 600;
      a {
        color: #435fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/website/components/downloadBlock.vue